import { CaretRight } from "@/components/shared/icons";
import { Card, CardContent, Image, View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import MassageCreditAccount from "@/assets/images/3d-icons/home-massage.png";
import BeautyCreditAccount from "@/assets/images/3d-icons/home-beauty.png";
import PetCreditAccount from "@/assets/images/3d-icons/pet-sitting.png";
import { useRoute } from "@/components/shared/router";
import type { CreditOverviewCardProps } from "./CreditAccount.container";
import { useProfileState } from "@/store/profile";

const CREDIT_CONFIG: Record<
  CreditOverviewCardProps["type"],
  { title: string; icon: string }
> = {
  massage: {
    title: "Massage Credit",
    icon: MassageCreditAccount,
  },
  beauty: {
    title: "Beauty Credit",
    icon: BeautyCreditAccount,
  },
  pet: {
    title: "Pet Care Credit",
    icon: PetCreditAccount,
  },
};

const CREDIT_PAGE_KEY_CONFIG: Record<
  CreditOverviewCardProps["type"],
  "creditAccountMassage" | "creditAccountBeauty" | "creditAccountPet"
> = {
  massage: "creditAccountMassage",
  beauty: "creditAccountBeauty",
  pet: "creditAccountPet",
};

export const CreditOverviewCard = ({
  type,
  balance,
}: CreditOverviewCardProps) => {
  const { push } = useRoute();
  const { title, icon } = CREDIT_CONFIG[type];
  const { setCreditAccountType } = useProfileState();

  const emptyBalance = parseInt(balance) === 0;

  const handleClick = () => {
    push({
      pageKey: CREDIT_PAGE_KEY_CONFIG[type],
    });
    setCreditAccountType(type);
  };

  return (
    <Card shadow="sm" onClick={handleClick} className="h-[136px]">
      <CardContent>
        <View className="flex h-full flex-col">
          <Image
            src={icon}
            className="size-10 md:size-12"
            width={32}
            height={32}
          />
          <View className="flex w-full flex-1 flex-col gap-1">
            <View className="align-start flex flex-row gap-1">
              <Typography variant="body-sm" color="foreground-intermediate">
                {title}
              </Typography>
            </View>

            <View className="flex w-full flex-1 flex-row items-start justify-between">
              <Typography variant="label-lg">${balance}</Typography>

              <View className="flex flex-row items-center gap-2 pt-1">
                <CaretRight className="size-4" size={16} />
              </View>
            </View>
            {emptyBalance && (
              <Typography variant="caption-md" color="foreground-intermediate">
                Top up now to add {title}
              </Typography>
            )}
          </View>
        </View>
      </CardContent>
    </Card>
  );
};
